<script setup lang="ts">
interface ListHeaderProps {
  title: string
  total: number
}

const {title = 'Title', total = 0} = defineProps<ListHeaderProps>();

</script>

<template>
  <div class="content__header">
    <h3 class="title">
      {{ title }}
    </h3>
    <div class="number">
      {{ total }}
    </div>
    <slot name="actions" />
  </div>
</template>

<style lang="scss" scoped>
.content__header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .title {
    font-size: 14px;
    font-weight: bold;
    margin-right: 9px;
  }

  .number {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    //width: 28px;
    //height: 28px;
    font-size: 12px;
    line-height: 14px;
    padding: 8px 11px;
    margin-right: 10px;

    &::before,
    &::after {
      position: absolute;
      z-index: -2;
      content: "";
      top: -1px;
      left: -1px;
      right: -1px;
      bottom: -1px;
      border-radius: 5px;
      background: linear-gradient(45deg, var(--primary-color, #2D2D86) 0%, rgba(240, 73, 79, 1) 100%);
    }

    &::after {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: #fff;
      z-index: -1;
    }
  }
}
</style>
